$(function () {
	$('.plan__tabs-item').on('click',function () {
		var $plan = $('.plan');
		$('.plan__tabs-item').removeClass('plan__tabs-item--active');
		$(this).addClass('plan__tabs-item--active');

		var color = $(this).attr('data-color');

		$('.plan__slider .swiper-navs').toggleClass('swiper-navs--white');
		$plan.toggleClass('plan--white');

		$plan.animate({opacity: 0.3}, 200, function () {
			$plan.css({
				'background-color': color
			});
			$plan.animate({opacity: 1}, 200);
		});
	});
});
